// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
const { createSelector } = require('reselect')
// Shared imports
const BemEntity = require('shared/bem')
const { formatCount } = require('shared/string-utils')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const SimpleNav = require('client-v2/common/components/simple-nav')
const { registerComponentEventHandlers } = require('client-v2/common/components/utils')
const {
  userProfileCollectionsHref,
  userProfileCollectionsCreatedHref,
  userProfileCollectionsSubscribedHref,
  userProfilePostsHref
} = require('client-v2/common/models/user/actions')
// Container imports
const ProfileUserRecord = require('../profile-user/record')
const ProfileUserStatsRecord = require('../profile-user-stats/record')

const containerBemEntity = BemEntity('UserProfileContentNav')
const primaryNavBemEntity = BemEntity('UserProfileContentPrimaryNav')
const collectionsNavBemEntity = BemEntity('UserProfileContentCollectionsNav')

class UserProfileContentNav extends React.PureComponent {

  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    registerComponentEventHandlers(this)
    this.primaryNavItemsSelector = this.createPrimaryNavItemsSelector()
    this.collectionsNavItemsSelector = this.createCollectionsNavItemsSelector()
  }

  createCollectionsNavItemsSelector() {
    return createSelector(
      [
        props => props.profileUser,
        props => props.profileUserStats
      ],
      (profileUser, profileUserStats) => [
        {
          id: 'created',
          href: userProfileCollectionsCreatedHref(profileUser),
          label: `Created • ${formatCount(profileUserStats.mixes)}`,
          onClick: this.onCollectionsCreatedClick
        },
        {
          id: 'subscribed',
          href: userProfileCollectionsSubscribedHref(profileUser),
          label: `Subscribed • ${formatCount(profileUserStats['followed_mixes'])}`,
          onClick: this.onCollectionsSubscribedClick
        }
      ]
    )
  }

  createPrimaryNavItemsSelector() {
    return createSelector(
      [
        props => props.profileUser,
        props => props.profileUserStats
      ],
      (profileUser, profileUserStats) => [
        {
          id: 'posts',
          href: userProfilePostsHref(profileUser),
          label: `Posts • ${formatCount(profileUserStats.posts)}`,
          onClick: this.onPostsClick
        },
        {
          id: 'collections',
          href: userProfileCollectionsHref(profileUser),
          label: `Collections • ${formatCount(profileUserStats.mixes)}`,
          onClick: this.onCollectionsClick
        }
      ]
    )
  }

  renderCollectionsNav() {
    if (!this.props.collectionsNavSelected) {
      return null
    }
    return tag(SimpleNav, {
      bemEntity: collectionsNavBemEntity,
      className: containerBemEntity.element('collections-nav'),
      items: this.collectionsNavItemsSelector(this.props),
      selectedItemId: this.props.collectionsNavSelected
    })
  }

  renderPrimaryNav() {
    return tag(SimpleNav, {
      bemEntity: primaryNavBemEntity,
      className: containerBemEntity.element('primary-nav'),
      items: this.primaryNavItemsSelector(this.props),
      selectedItemId: this.props.primaryNavSelected
    })
  }

  render() {
    if (this.props.isHidden) {
      return null
    }
    return tag('div', {
      className: containerBemEntity.block()
    }, ...[
      this.renderPrimaryNav(),
      this.renderCollectionsNav()
    ])
  }

}

UserProfileContentNav.propTypes = {
  // Flags
  isHidden: PropTypes.bool,
  // Values
  collectionsNavSelected: PropTypes.oneOf(['created', 'subscribed']),
  primaryNavSelected: PropTypes.oneOf(['collections', 'posts']),
  profileUser: PropTypes.shape(ProfileUserRecord.propTypes),
  profileUserStats: PropTypes.shape(ProfileUserStatsRecord.propTypes)
}

// Callbacks
UserProfileContentNav.eventHandlerKeys = [
  'onCollectionsClick',
  'onCollectionsCreatedClick',
  'onCollectionsSubscribedClick',
  'onPostsClick'
]
UserProfileContentNav.eventHandlerKeys.forEach(key => {
  UserProfileContentNav.propTypes[key] = PropTypes.func
})

module.exports = UserProfileContentNav
